import styled from 'styled-components';
import { PROGRESS_BAR_COLORS } from '../utils';

export const ProgressBarContainer = styled.div`
  position: relative;
  width: 100%;
  height: 25px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 10px;
  display: flex;
  margin-top: 2rem;

  @keyframes slideIndicatorAndPercentage {
    from {
      left: 0%;
    }
    to {
      left: var(--indicator-final-position);
    }
  }
`;

export const Segment = styled.div`
  height: 100%;
  flex-grow: 1;
  transition: width 0.3s ease;

  &:nth-child(1) {
    background: ${PROGRESS_BAR_COLORS.VALUE_25};
    border-radius: 10px 0 0 10px;
  }
  &:nth-child(2) {
    background: ${PROGRESS_BAR_COLORS.VALUE_50};
  }
  &:nth-child(3) {
    background: ${PROGRESS_BAR_COLORS.VALUE_75};
  }
  &:nth-child(4) {
    background: ${PROGRESS_BAR_COLORS.VALUE_100};
    border-radius: 0 10px 10px 0;
  }
`;

export const ProgressIndicator = styled.div`
  position: absolute;
  top: -20px;
  color: black;
  font-size: 20px;
  animation: slideIndicator 1s ease-out forwards;
  animation: slideIndicatorAndPercentage 2s ease-out forwards;
`;

export const ProgressPercentage = styled.div`
  position: absolute;
  text-align: center;
  top: -35px;
  font-weight: bold;
  font-size: 12px;
  animation: slideIndicatorAndPercentage 2s ease-out forwards;
`;

export const Ruler = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 3px;
`;

export const Mark = styled.span`
  font-size: 10px;
`;
